import { render, staticRenderFns } from "./StockCategoryTree.vue?vue&type=template&id=08a9d0e6&"
import script from "./StockCategoryTree.vue?vue&type=script&lang=js&"
export * from "./StockCategoryTree.vue?vue&type=script&lang=js&"
import style0 from "./StockCategoryTree.vue?vue&type=style&index=0&id=08a9d0e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports